export default {"src":"/_next/static/media/Step2.0d365f01.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};